// extracted by mini-css-extract-plugin
module.exports = {"variables":"'../../styles/variables.css'","_menuwidth":"800px","_widescreen":"1320px","_toolbar_height":"2.4rem","Layout":"Layout_Layout__3SBgk"};